import {AuthConfigParameter} from './AuthConfigParameter';
import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class AuthConfig extends ConnectBasicEntity {
host: string;
kind: string;
method: string;
parameters: {[key: string]: AuthConfigParameter};
}

